var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',_vm._b({attrs:{"is-active":_vm.isActive,"next":function () { return _vm.nav(1); },"prev":function () { return _vm.nav(-1); },"close":_vm.close,"step":_vm.currentStep}},'Wrapper',_vm.step,false))}
var staticRenderFns = []

export { render, staticRenderFns }